var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("FormSubmitPopup", {
    attrs: {
      title: _vm.title,
      rightMethod: _vm.onSubmitted,
      rightButtonText: _vm.actionText,
      large: ""
    },
    on: {
      popupClose: function($event) {
        return _vm.$emit("input", false)
      }
    },
    scopedSlots: _vm._u([
      {
        key: "input",
        fn: function() {
          return [
            _c(
              "v-layout",
              { attrs: { row: "", wrap: "" } },
              [
                _c(
                  "v-flex",
                  { attrs: { sm12: "" } },
                  [
                    _c("v-text-field", {
                      attrs: {
                        label: _vm.$t("PromotionTitle"),
                        required: "",
                        rules: [_vm.fieldIsRequired("Promotion title")],
                        "prepend-icon": "subtitles"
                      },
                      model: {
                        value: _vm.newPromotion.title,
                        callback: function($$v) {
                          _vm.$set(_vm.newPromotion, "title", $$v)
                        },
                        expression: "newPromotion.title"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "v-layout",
              { attrs: { wrap: "", "align-center": "" } },
              [
                _c(
                  "v-flex",
                  { attrs: { sm4: "" } },
                  [
                    _c(
                      "v-menu",
                      {
                        ref: "startDatePicker",
                        attrs: {
                          lazy: "",
                          "close-on-content-click": false,
                          transition: "scale-transition",
                          "offset-y": "",
                          "full-width": "",
                          "nudge-right": 40,
                          "min-width": "290px",
                          "return-value": _vm.newPromotion.startDate
                        },
                        on: {
                          "update:returnValue": function($event) {
                            return _vm.$set(
                              _vm.newPromotion,
                              "startDate",
                              $event
                            )
                          },
                          "update:return-value": function($event) {
                            return _vm.$set(
                              _vm.newPromotion,
                              "startDate",
                              $event
                            )
                          }
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "activator",
                            fn: function(ref) {
                              var on = ref.on
                              return [
                                _c(
                                  "v-text-field",
                                  _vm._g(
                                    {
                                      attrs: {
                                        label: _vm.$t("startDate"),
                                        required: "",
                                        rules: [
                                          _vm.fieldIsRequired("Start date")
                                        ],
                                        "prepend-icon": "event",
                                        readonly: ""
                                      },
                                      model: {
                                        value: _vm.startDateFormatted,
                                        callback: function($$v) {
                                          _vm.startDateFormatted = $$v
                                        },
                                        expression: "startDateFormatted"
                                      }
                                    },
                                    on
                                  )
                                )
                              ]
                            }
                          }
                        ]),
                        model: {
                          value: _vm.startDatePicker,
                          callback: function($$v) {
                            _vm.startDatePicker = $$v
                          },
                          expression: "startDatePicker"
                        }
                      },
                      [
                        _vm._v(" "),
                        _c(
                          "v-date-picker",
                          {
                            attrs: { scrollable: "" },
                            model: {
                              value: _vm.newPromotion.startDate,
                              callback: function($$v) {
                                _vm.$set(_vm.newPromotion, "startDate", $$v)
                              },
                              expression: "newPromotion.startDate"
                            }
                          },
                          [
                            _c("v-spacer"),
                            _vm._v(" "),
                            _c(
                              "v-btn",
                              {
                                attrs: { flat: "", color: "primary" },
                                on: {
                                  click: function($event) {
                                    _vm.startDatePicker = false
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("cancel")))]
                            ),
                            _vm._v(" "),
                            _c(
                              "v-btn",
                              {
                                attrs: { flat: "", color: "primary" },
                                on: {
                                  click: function($event) {
                                    return _vm.$refs.startDatePicker.save(
                                      _vm.newPromotion.startDate
                                    )
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("ok")))]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("v-flex", { attrs: { sm1: "" } }),
                _vm._v(" "),
                _c(
                  "v-flex",
                  { attrs: { sm4: "" } },
                  [
                    _c(
                      "v-menu",
                      {
                        ref: "endDatePicker",
                        attrs: {
                          lazy: "",
                          "close-on-content-click": false,
                          transition: "scale-transition",
                          "offset-y": "",
                          "full-width": "",
                          "nudge-right": 40,
                          "min-width": "290px",
                          "return-value": _vm.newPromotion.endDate
                        },
                        on: {
                          "update:returnValue": function($event) {
                            return _vm.$set(_vm.newPromotion, "endDate", $event)
                          },
                          "update:return-value": function($event) {
                            return _vm.$set(_vm.newPromotion, "endDate", $event)
                          }
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "activator",
                            fn: function(ref) {
                              var on = ref.on
                              return [
                                _c(
                                  "v-text-field",
                                  _vm._g(
                                    {
                                      attrs: {
                                        label: _vm.$t("endDate"),
                                        required: "",
                                        rules: [
                                          _vm.fieldIsRequired("End date")
                                        ],
                                        "prepend-icon": "event",
                                        readonly: ""
                                      },
                                      model: {
                                        value: _vm.endDateFormatted,
                                        callback: function($$v) {
                                          _vm.endDateFormatted = $$v
                                        },
                                        expression: "endDateFormatted"
                                      }
                                    },
                                    on
                                  )
                                )
                              ]
                            }
                          }
                        ]),
                        model: {
                          value: _vm.endDatePicker,
                          callback: function($$v) {
                            _vm.endDatePicker = $$v
                          },
                          expression: "endDatePicker"
                        }
                      },
                      [
                        _vm._v(" "),
                        _c(
                          "v-date-picker",
                          {
                            attrs: { scrollable: "" },
                            model: {
                              value: _vm.newPromotion.endDate,
                              callback: function($$v) {
                                _vm.$set(_vm.newPromotion, "endDate", $$v)
                              },
                              expression: "newPromotion.endDate"
                            }
                          },
                          [
                            _c("v-spacer"),
                            _vm._v(" "),
                            _c(
                              "v-btn",
                              {
                                attrs: { flat: "", color: "primary" },
                                on: {
                                  click: function($event) {
                                    _vm.endDatePicker = false
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("cancel")))]
                            ),
                            _vm._v(" "),
                            _c(
                              "v-btn",
                              {
                                attrs: { flat: "", color: "primary" },
                                on: {
                                  click: function($event) {
                                    return _vm.$refs.endDatePicker.save(
                                      _vm.newPromotion.endDate
                                    )
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("ok")))]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("v-flex", { attrs: { sm1: "" } }),
                _vm._v(" "),
                _c(
                  "v-tooltip",
                  {
                    attrs: { bottom: "" },
                    scopedSlots: _vm._u([
                      {
                        key: "activator",
                        fn: function(ref) {
                          var on = ref.on
                          return [
                            _c(
                              "v-flex",
                              _vm._g({ attrs: { sm2: "" } }, on),
                              [
                                _c("v-checkbox", {
                                  attrs: { label: _vm.$t("AllowMultiple") },
                                  model: {
                                    value: _vm.newPromotion.isAllowMultiple,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.newPromotion,
                                        "isAllowMultiple",
                                        $$v
                                      )
                                    },
                                    expression: "newPromotion.isAllowMultiple"
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        }
                      }
                    ])
                  },
                  [
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(_vm.$t("PromotionEditTips")))])
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "v-layout",
              { attrs: { wrap: "", "align-center": "" } },
              [
                _c(
                  "v-flex",
                  { attrs: { sm4: "" } },
                  [
                    _c("v-text-field", {
                      attrs: {
                        label: _vm.$t("threshold"),
                        rules: [
                          _vm.fieldIsNumber("Bonus"),
                          _vm.fieldIsNoLessThanZero("Bonus")
                        ],
                        "prepend-icon": "attach_money"
                      },
                      on: {
                        keyup: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.addBonusItem()
                        }
                      },
                      model: {
                        value: _vm.tierDepositInput.threshold,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.tierDepositInput,
                            "threshold",
                            _vm._n($$v)
                          )
                        },
                        expression: "tierDepositInput.threshold"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("v-flex", { attrs: { sm1: "" } }),
                _vm._v(" "),
                _c(
                  "v-flex",
                  { attrs: { sm4: "" } },
                  [
                    _c("v-text-field", {
                      attrs: {
                        label: _vm.$t("bonus"),
                        rules: [
                          _vm.fieldIsNumber("Bonus"),
                          _vm.fieldIsNoLessThanZero("Bonus")
                        ],
                        "prepend-icon": "attach_money"
                      },
                      on: {
                        keyup: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.addBonusItem()
                        }
                      },
                      model: {
                        value: _vm.tierDepositInput.bonus,
                        callback: function($$v) {
                          _vm.$set(_vm.tierDepositInput, "bonus", _vm._n($$v))
                        },
                        expression: "tierDepositInput.bonus"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("v-flex", { attrs: { sm1: "" } }),
                _vm._v(" "),
                _c(
                  "v-flex",
                  { attrs: { sm2: "" } },
                  [
                    _c(
                      "v-btn",
                      {
                        attrs: {
                          right: "",
                          disabled: !_vm.canAddNewThreshold,
                          color: "primary"
                        },
                        on: {
                          click: function($event) {
                            return _vm.addBonusItem()
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("add")))]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-layout",
                  [
                    _c(
                      "v-flex",
                      { attrs: { sm12: "" } },
                      [
                        _c(
                          "v-data-table",
                          {
                            staticClass: "elevation-2 myDense",
                            attrs: {
                              headers: _vm.headers,
                              items: _vm.newPromotion.tierDeposits,
                              "item-key": "reportKey",
                              pagination: _vm.pagination
                            },
                            on: {
                              "update:pagination": function($event) {
                                _vm.pagination = $event
                              }
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "items",
                                fn: function(ref) {
                                  var item = ref.item
                                  return [
                                    _c("td", { staticClass: "subheading" }, [
                                      _vm._v(_vm._s(item.threshold))
                                    ]),
                                    _vm._v(" "),
                                    _c("td", { staticClass: "text-xs-left" }, [
                                      _vm._v(_vm._s(item.bonus))
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticClass: "text-xs-center" },
                                      [
                                        _c(
                                          "v-layout",
                                          [
                                            _c(
                                              "v-flex",
                                              [
                                                _c(
                                                  "v-btn",
                                                  {
                                                    attrs: {
                                                      dark: "",
                                                      color: "secondary",
                                                      flat: ""
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        $event.stopPropagation()
                                                        return _vm.deleteBonus(
                                                          item
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(_vm.$t("delete"))
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                }
                              }
                            ])
                          },
                          [
                            _vm._v(" "),
                            _c(
                              "template",
                              { slot: "no-data" },
                              [
                                _c(
                                  "v-layout",
                                  {
                                    attrs: {
                                      "align-center": "",
                                      "justify-center": ""
                                    }
                                  },
                                  [
                                    _c(
                                      "v-flex",
                                      { attrs: { sm4: "" } },
                                      [
                                        _c("v-text-field", {
                                          attrs: {
                                            disabled: "",
                                            center: "",
                                            rules: [
                                              function(v) {
                                                return _vm.$t(
                                                  "PromotionEditTipsNoData"
                                                )
                                              }
                                            ]
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          2
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "v-layout",
              { attrs: { "pt-3": "", "justify-center": "", wrap: "" } },
              [
                _c("v-textarea", {
                  staticClass: "thinBox",
                  attrs: {
                    id: "promotion_note",
                    label: _vm.$t("note"),
                    outline: ""
                  },
                  model: {
                    value: _vm.newPromotion.note,
                    callback: function($$v) {
                      _vm.$set(_vm.newPromotion, "note", $$v)
                    },
                    expression: "newPromotion.note"
                  }
                })
              ],
              1
            )
          ]
        },
        proxy: true
      }
    ]),
    model: {
      value: _vm.value,
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7cd56acd", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7cd56acd","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PromotionEdit.vue
// module id = null
// module chunks = 